

import Navbarr from '../../components/Navbarr'
import Hero from '../../components/Hero'
import Benefits from '../../components/Benefits'
import Features from '../../components/Features'
import CoreFeatures from '../../components/Core-features'
import Contact from '../../components/Contact'
import Footer from '../../components/Footer'

export default function LandingPage() {
  return (
    <main className="min-h-screen leading-normal">
      <Navbarr />
      <Hero />
      <Benefits />
      <Features />
      <CoreFeatures />
      <Contact />
      <Footer />
    </main>
  )
}


